import {useCallback, useState, useEffect} from 'react';
import ethereum from 'decentralized/ethereum.js';
import accounts from "accounts/Accounts.js"

export const useFavorites = ({type, contentHash, disabled}) => {
    let [isFavorited, setIsFavorited] = useState(undefined);
    const toggleFavorite = useCallback((e) => {
        e.stopPropagation();
        ethereum.xanadu.rateSound(contentHash, isFavorited ? 0 : 5, type);
        setIsFavorited(!isFavorited);
    }, [setIsFavorited, contentHash, isFavorited, type]);

    useEffect(() => {
        if (disabled) {
            return;
        }

        let unmounted = false;
        accounts.getAccount()
            .then(
                user => 
                    user && ethereum.xanadu.getSoundRating(contentHash, type, user)
                    .then(x => {
                        if (!unmounted) {
                            setIsFavorited(x === 5);
                        }
                    }));
        return () => unmounted = true;
    }, [setIsFavorited, contentHash, type, disabled]);

    return {toggleFavorite, isFavorited};
};
